<template>
  <div>
    <div
      class="floating-btn-back d-flex align-items-center p-2"
      onclick="history.back()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="38"
        height="38"
        fill="#fff"
        class="bi bi-arrow-left-circle-fill mx-2"
        viewBox="0 0 16 16"
      >
        <path
          d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
        />
      </svg>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <div
        class="shadow-lg revise-container p-4 col-11 col-sm-11 col-md-8 col-lg-8 col-xl-8 d-flex justify-content-center align-items-center flex-column"
      >
        <div class="w-100 d-flex justify-content-between">
          <label class="l-modal" for="">Enter Your Note:</label>
          <button class="btn-subt" @click="removeNote">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#000000"
              class="bi bi-dash"
              viewBox="0 0 16 16"
            >
              <path
                d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"
              />
            </svg>
          </button>
        </div>

        <div class="w-100" v-for="(note, index) in notes" :key="index">
          <textarea
            class="n-input w-100"
            name="text_revision"
            id="t-revision"
            cols="40"
            rows="5"
            v-model="remixText[index]"
            maxlength="1000"
            placeholder="I need to ..."
          ></textarea>
        </div>
        <div
          class="w-100 px-4 pt-2 d-flex justify-content-end align-items-center"
        >
          <!-- <p class="pt-1 px-3 error-txt" :class="textError">
            Please enter required fields..
          </p> -->
          <!-- <img :class="loadingShow" src="../assets/loading.svg" alt="" /> -->
          <button @click="addNote" class="btn-revision mx-3">Add Note</button>

          <button class="btn-revision" :disabled="btnDisabled" @click="sendRev">
            Send Revision
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  mounted() {},
  data() {
    return {
      disableBtn: 0,
      remixText: [],
      notes: 1,
    };
  },

  computed: {
    loadingBtnClass() {
      return !this.trackStatus ? "a-track" : "a-track-disable";
    },
    btnDisabled() {
      return this.disableBtn ? true : false;
    },
  },
  methods: {
    sendRev() {
      this.disableBtn = 1;
      if (this.remixText.length > 0) {
        ("sending");
        this.$store
          .dispatch("trackData/setUpdateRemixData", {
            data: this.remixText,
            type: "",
          })
          .then(() => {
            this.$store.dispatch("apiEvents/useRevisionCredit").then(() => {
              this.$store
                .dispatch("trackData/sendRemixData", {
                  trackid: this.$route.params.id,
                })
                .then(() => {
                  this.$store.dispatch("trackData/setTrackStatus", "Revising");
                });
            });
          })
          .then(() => {
            this.$router.push({
              name: "track",
              params: { id: this.$route.params.id },
            });
          });
      }
    },
    addNote() {
      if (this.notes <= 2) {
        this.notes += 1;
      } else {
        return;
      }
    },
    removeNote() {
      if (this.notes > 1) {
        this.notes -= 1;
      } else {
        return;
      }
    },
  },
};
</script>
<style scoped>
.revise-container {
  background-color: rgb(255, 255, 255);
  border-radius: 7px;
  color: #000000;
}

.n-input {
  border: 0px !important;
  font-size: 14px;
  padding: 8px !important;
  background-color: rgb(238, 238, 238);
  border-radius: 5px;
  border: 1px solid rgb(238, 238, 238);
}

.btn-send {
  background-color: #7dfcd5;
  height: 34px;
  margin: 0px !important;
  font-size: 14px;
}

.btn-revision {
  padding: 6px 12px !important;
  background-color: #585858;
  color: #ffffff;
  border-radius: 20px;
  border: 0px solid #ebebeb;
}

.btn-subt {
  background: transparent;
  border: none;
}
</style>
